import { render, staticRenderFns } from "./WizardStep2.vue?vue&type=template&id=3ff0425e"
import script from "./WizardStep2.vue?vue&type=script&lang=js"
export * from "./WizardStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports